import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { cn } from '@/utils/tailwind.util';
const QuizCardRoot = forwardRef<HTMLElement, ComponentPropsWithoutRef<'article'>>((props, ref) => {
  const {
    children,
    className,
    ...rest
  } = props;
  return <article ref={ref} className={cn('flex flex-col items-center bg-default border border-opacity-black-2 rounded-[16px] overflow-hidden', className)} {...rest}>
      {children}
    </article>;
});
QuizCardRoot.displayName = 'QuizCardRoot';
const QuizCardHeader = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>((props, ref) => {
  const {
    children,
    className,
    ...rest
  } = props;
  return <div className={cn('flex items-center justify-center px-lg w-full', className)} ref={ref} {...rest}>
      {children}
    </div>;
});
QuizCardHeader.displayName = 'QuizCardHeader';
const QuizCardContent = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>((props, ref) => {
  const {
    children,
    className,
    ...rest
  } = props;
  return <div className={cn('flex flex-col pb-lg pt-0 gap-lg w-full px-lg', className)} ref={ref} {...rest}>
      {children}
    </div>;
});
QuizCardContent.displayName = 'QuizCardContent';
const QuizCardFooter = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>((props, ref) => {
  const {
    children,
    className,
    ...rest
  } = props;
  return <div className={cn('flex justify-between py-[14px] w-full px-md border-t border-assistive', className)} ref={ref} {...rest}>
      {children}
    </div>;
});
QuizCardFooter.displayName = 'QuizCardFooter';
export const QuizCard = {
  Root: QuizCardRoot,
  Header: QuizCardHeader,
  Content: QuizCardContent,
  Footer: QuizCardFooter
};